import { Flex } from '@components/grid';
import { QuantityPicker } from '@components/quantity-picker';
import { P } from '@components/typography/new';
import { colors, RECOMMENDATION_ENGINE } from '@nandosaus/constants';
import { useField } from 'formik';
import { forwardRef } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import { Section } from '../../ui';
import { QuestionHeader } from '../components';

const { maxGuestsDineIn, maxGuestsCatering } = RECOMMENDATION_ENGINE;

export const SelectGroup = forwardRef((props, ref) => {
  const validateAdults = adults => (adults === 0 ? 'Add one or more adults to continue' : undefined);

  const { CartStore } = useRootStore();
  const isCatering = CartStore.orderType === 'CATERING';
  const maxGuests = isCatering ? maxGuestsCatering : maxGuestsDineIn;

  const [adultsField, adultsMeta, adultsHelper] = useField({ name: 'group.adults', validate: validateAdults });
  // eslint-disable-next-line no-unused-vars
  const [kidsField, kidsMeta, kidsHelper] = useField({ name: 'group.kids' });
  const { error, touched } = adultsMeta;

  return (
    <>
      <Section borderColor={colors.warmWhite3} pt="0" ref={ref}>
        <QuestionHeader
          title="How many guests?"
          description="This’ll give us an idea of how much food to give you. Obviously."
          required
        />
        {error && touched && <P color="red600">{error}</P>}

        <Flex flexDirection="column" gap="16px">
          <Flex width="100%" alignItems="center">
            <P variant="large-bold" mr="38px">
              {isCatering ? 'Guests' : 'Adults'}
            </P>
            <QuantityPicker
              quantity={adultsField.value}
              increment={() => {
                adultsHelper.setTouched(true, false);
                adultsHelper.setValue(adultsField.value + 1);
              }}
              decrement={() => {
                adultsHelper.setTouched(true, false);
                adultsHelper.setValue(adultsField.value - 1);
              }}
              onQuantityChange={value => {
                adultsHelper.setTouched(true, false);
                adultsHelper.setValue(value);
              }}
              max={maxGuests - kidsField.value}
              min={0}
            />
          </Flex>
          {!isCatering && (
            <>
              <Flex width="100%" alignItems="center">
                <P variant="large-bold" mr="19px">
                  Children
                </P>
                <QuantityPicker
                  quantity={kidsField.value}
                  increment={() => {
                    kidsHelper.setTouched(true, false);
                    kidsHelper.setValue(kidsField.value + 1);
                  }}
                  decrement={() => {
                    kidsHelper.setTouched(true, false);
                    kidsHelper.setValue(kidsField.value - 1);
                  }}
                  onQuantityChange={value => {
                    kidsHelper.setTouched(true, false);
                    kidsHelper.setValue(value);
                  }}
                  max={maxGuests - adultsField.value}
                  min={0}
                />
              </Flex>
              <P variant="standard" color="grey70">
                Number of kids will indicate how many Nandino (Kids’ meals) we recommend
              </P>
            </>
          )}
        </Flex>
      </Section>
      <Flex height="4px" width="200%" backgroundColor="warmWhite3" mx="-50px" />
    </>
  );
});
